// src/admin/utils/onboardingUtils.js
//
// Shared helpers for deciding when to show admin onboarding experiences.

/**
 * Returns true when the admin onboarding checklist should be shown
 * for the given user.
 *
 * Conditions (kept in sync with useOnboardingProgress):
 *  - User is the organization's first user
 *  - Onboarding has not been completed
 *  - Onboarding has not been dismissed
 */
export function shouldShowOnboardingForUser(user) {
  if (!user) return false;

  const isFirstUser = !!user.first_user;
  const onboardingPrefs = (user.preferences && user.preferences.onboarding) || {};

  const isCompleted = !!onboardingPrefs.completed_at;
  const isDismissed = !!onboardingPrefs.dismissed_at;

  return isFirstUser && !isCompleted && !isDismissed;
}

